module.exports = __webpack_public_path__ + "static/images/lock_mask.e728ef4.png";